// extracted by mini-css-extract-plugin
export default {"loader_container":"MediumLoader_loader_container__w6SjO","loader":"MediumLoader_loader__y4w4r","spinner-c7wet2":"MediumLoader_spinner-c7wet2__xFjFS"};